/**
 * Campaigns with this flow — Tres Commas' own campaign list
 * (GET /tres-commas/campaigns). Never Voluum's: the ids are shared, so the
 * Voluum list would name Voluum campaigns for a Tres Commas flow.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { trackerLabel } from '@trafficpulse/shared';

import { useTresCommasCampaigns } from '@/hooks/tres-commas';

import LinkedCampaignsList from './LinkedCampaignsList';

const TresCommasLinkedCampaigns: FC<{ flowId: string }> = ({ flowId }) => {
  const query = useTresCommasCampaigns();
  return (
    <LinkedCampaignsList
      flowId={flowId}
      campaigns={query.data}
      isLoading={query.isLoading}
      trackerName={trackerLabel('tres-commas')}
    />
  );
};

export default TresCommasLinkedCampaigns;
